import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import BAList from './components/BAList';
import BARecord from './components/BARecord';

const { Cell } = ResponsiveGrid;

const BA = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="BA列表"
        breadcrumbs={[
          {
            name: 'BA系統',
          },
          {
            name: 'BA列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <BAList />
      <h1>BA記錄</h1>
      <BARecord />
    </Cell>
  </ResponsiveGrid>
);

export default BA;
